export default "__VITE_ASSET__EcJzayxA__"